// ES
export const propAuthLocksHc = {
  autoridades: {
    breadcrumbCurrent: "Autoridades competentes",
    selectorLabel: "Selecciona la autoridad policial de tu zona",

    // Fragmentos de estado compartidos
    msgConnected: "Conectado.",
    msgValidated: "Validado.",
    msgValidationError: "Error de validación.",

    // SES Hospedajes
    sesSubtitle: "Secretaría de Estado de Seguridad – Ministerio del Interior",
    sesConnectedText: "Los check-in se enviarán automáticamente a SES Hospedajes.",
    sesVerifyCreds: "Verifica las credenciales ingresadas.",
    sesNotConnected: "Aún no has conectado una cuenta de SES Hospedajes.",
    updateConnectedAccount: "Actualizar cuenta conectada",

    // Ertzaintza A19
    ertzSubtitle: "Policía Autonómica del País Vasco – Registro de viajeros",
    ertzConnectedText: "Los check-in se enviarán automáticamente a la Ertzaintza.",
    ertzVerifyCif: "Verifica el CIF y el código de establecimiento.",
    ertzCredsSaved: 'Credenciales guardadas. Pulsa "Verificar conexión" para comprobar el acceso.',
    ertzCifLabel: "CIF del establecimiento",
    ertzCifPlaceholder: "Ej. B12345678",
    ertzCifHint: "Máx. 10 caracteres. CIF del arrendador registrado en Ertzaintza.",
    ertzCodeLabel: "Código de establecimiento",
    ertzCodePlaceholder: "Ej. 01000001",
    ertzCodeHint: "Asignado por Ertzaintza al registrar el establecimiento.",
    envLabel: "Entorno",
    envPre: "Pre-producción (pruebas)",
    envPro: "Producción",
    envHint: 'Usa "Pre-producción" para validar antes de activar en producción.',
    verifying: "Verificando...",
    verifyConnection: "Verificar conexión",
    saving: "Guardando...",
    updateCredentials: "Actualizar credenciales",
    saveAndConnect: "Guardar y conectar",

    // Mossos d'Esquadra
    mossosSubtitle: "Generalitat de Catalunya – Registre de viatgers d'establiments d'hostalatge",

    // SIRE
    sireSubtitle: "Sistema de Información de Registro de Extranjeros – Migración Colombia",
    sireConnectedText: "Los check-in se enviarán automáticamente.",
    sireRevisaCreds: "Revisa las credenciales.",
    docTypeLabel: "Tipo de documento",
    selectTypePlaceholder: "Selecciona tipo",
    docNumberLabel: "Número de documento",
    docNumberPlaceholder: "Ej. 123456789",
    passwordLabel: "Contraseña",
    sirePasswordPlaceholder: "Contraseña SIRE",
    showHideTitle: "Mostrar/ocultar",
    saveChanges: "Guardar cambios",

    // TRA
    traSubtitle: "Ministerio de Comercio, Industria y Turismo – Token de autorización",
    traReportsText: "Reportes automáticos habilitados.",
    traRevisaToken: "Revisa el token/RNT.",
    traTokenLabel: "Token de autorización",
    traTokenPlaceholder: "Pega aquí el token emitido por el TRA",
    traCurrentToken: "Token actual: {token}",
    traNoTokenHint: "Si aún no tienes un token PMS, puedes generarlo desde",
    traRntLabel: "RNT del establecimiento",
    traRntPlaceholder: "Solo números (ej. 123456)",
    traRntHint: "Debe ser el RNT activo del establecimiento (5 a 15 dígitos).",

    // Tipos de documento (Colombia)
    docTypeCitizenId: "Cédula de ciudadanía",
    docTypeForeignerId: "Cédula de extranjería",

    // Alloggiati Web (placeholder residual)
    alloggiatiIdPlaceholder: "Ej. 1234",

    // Toasts / mensajes de script
    needSaveListing: "Necesitas guardar el listing primero.",
    authChangedErtz: "Autoridad cambiada a Ertzaintza (País Vasco).",
    authChangedMossos: "Autoridad cambiada a Mossos d'Esquadra (Catalunya).",
    authChangedSes: "Autoridad cambiada a SES Hospedajes.",
    authChangeError: "No se pudo cambiar la autoridad.",
    ertzSaved: "Credenciales Ertzaintza guardadas.",
    saveGenericError: "Error al guardar.",
    ertzSaveError: "Error guardando credenciales Ertzaintza.",
    ertzTestOk: "Conexión con Ertzaintza verificada correctamente.",
    testFailedCheck: "La verificación falló. Revisa los datos.",
    ertzTestError: "Error al verificar la conexión con Ertzaintza.",
    mossosNeedCreds: "Introduce el usuari y la paraula de pas de la web de Mossos.",
    mossosFound: "Se encontró {count} establecimiento. Elige el tuyo. | Se encontraron {count} establecimientos. Elige el tuyo.",
    mossosNoEstablishments: "No se encontraron establecimientos en esta cuenta.",
    mossosConnError: "No se pudo conectar con Mossos. Revisa usuari y contraseña.",
    mossosNeedFields: "Completa el identificador policial y el código de establecimiento.",
    mossosSaved: "Credenciales Mossos guardadas.",
    mossosSaveError: "Error guardando credenciales Mossos.",
    mossosTestOk: "Conexión con Mossos verificada correctamente.",
    mossosTestError: "Error al verificar la conexión con Mossos.",
    mossosFileOk: "Fichero generado. Súbelo en la web de Mossos (Fitxers massius).",
    mossosNoTravelers: "No hay viajeros pendientes de enviar.",
    mossosConfigFirst: "Configura primero el establecimiento.",
    mossosFileError: "No se pudo generar el fichero.",
    sireCompleteData: "Completa los datos requeridos para SIRE.",
    sireSaved: "SIRE guardado correctamente.",
    sireSaveFailed: "No se pudo guardar SIRE.",
    sireSaveError: "Error guardando SIRE.",
    sireDeactivated: "SIRE desactivado.",
    sireActivated: "SIRE activado.",
    sireStateFailed: "No se pudo cambiar el estado SIRE.",
    sireStateError: "Error cambiando estado SIRE.",
    traNeedToken: "Ingresa el token y un RNT válido (solo números).",
    traSaved: "TRA guardado correctamente.",
    traSaveFailed: "No se pudo guardar TRA.",
    traSaveError: "Error guardando TRA.",
    traDeactivated: "TRA desactivado.",
    traActivated: "TRA activado.",
    traStateFailed: "No se pudo cambiar el estado TRA.",
    traStateError: "Error cambiando estado TRA.",
    stateChangeFailed: "No se pudo cambiar el estado.",
    alloggiatiStateError: "Error cambiando el estado Alloggiati Web.",
    ross1000StateError: "Error cambiando el estado ROSS 1000.",
  },

  smartLocks: {
    loadingConfig: "Cargando configuración…",
    accessKeyTypeLabel: "Tipo de clave de acceso",
    selectLockPlaceholder: "Selecciona cerradura",
    optionStatic: "Clave Estática",
    optionTtlock: "TTLock - Cerradura Dinámica",
    optionTedee: "Tedee - Cerradura Dinámica",
    optionShelly: "Shelly - Relé Inteligente",
    optionYacan: "YACAN - Cerradura Inteligente",
    optionAkiles: "Akiles - Cerradura Inteligente",
    optionOther: "Otra marca que no aparece aquí…",
    pillTedee: "Acceso dinámico (Tedee)",
    pillTtlock: "Acceso dinámico (TTLock)",
    pillShelly: "Apertura remota (Shelly)",
    pillYacan: "Acceso gestionado (YACAN)",
    pillAkiles: "Akiles conectado",
    pillStatic: "Acceso estático",
    pillOther: "Escríbenos y te ayudamos a integrarla",
    disconnecting: "Desconectando…",
    disconnect: "Desconectar",
    emptyTitle: "Conecta tu cerradura inteligente",
    emptyText: "Elige tu marca en el desplegable de arriba para conectarla y generar una clave nueva automática en cada reserva.",
    emptyBrandOther: "Otras marcas",
    unitFallback: "Unidad {id}",
    staticModeInfo: "Modo estático seleccionado. Ingresa una clave y pulsa Guardar para aplicarlo.",
    saveTypeError: "No se pudo guardar el tipo de acceso",
    disconnectSuccess: "Cerradura desconectada",
    disconnectError: "No se pudo desconectar la cerradura.",
  },

  rates: {
    pageTitle: "Tarifas",
    loading: "Cargando tarifas…",
    roomsCount: "{count} habitación | {count} habitaciones",
    singleUnit: "Unidad única",
    newBtn: "Nueva",
    colName: "Nombre",
    colAdjustment: "Ajuste",
    colFinal: "Precio final",
    labelMain: "Principal",
    labelDerived: "Derivada",
    base: "Base",
    editTitle: "Editar",
    copyTitle: "Copiar a otra unidad",
    deleteTitle: "Eliminar",
    noDerived: "No hay tarifas derivadas para este rate plan.",
    emptyTitle: "Sin tarifas principales",
    emptyText: "Crea una tarifa principal para esta unidad y luego podrás crear derivadas.",
    emptyCreate: "Crear primera tarifa principal",
    globalEmptyTitle: "No hay unidades cargadas",
    globalEmptyText: "Primero crea habitaciones/unidades para poder gestionar tarifas.",
    editRate: "Editar tarifa",
    newRate: "Nueva tarifa",
    fieldName: "Nombre",
    namePlaceholder: "Ej: Tarifa flexible",
    validityPeriod: "Periodo de validez",
    validityPermanent: "Permanente",
    validityCustom: "Personalizado",
    validityHintCustom: "Opcional: aplica sólo en el rango",
    validityHintPermanent: "Tarifa válida siempre",
    startLabel: "Inicio",
    endLabel: "Fin",
    pricePerNight: "Precio por noche",
    taxIncluded: "Impuestos incluidos",
    occupancy: "Ocupación",
    guestsNumber: "Número de huéspedes",
    minStay: "Reserva mínima",
    maxStay: "Reserva máxima",
    description: "Descripción",
    optional: "Opcional",
    rateplanBase: "Rate Plan Base",
    selectRateplanBase: "Selecciona un rate plan base",
    rateplanBaseHint: "Selecciona el rate plan sobre el cual se calculará esta tarifa derivada.",
    derivedNamePlaceholder: "Ej: Booking.com, Airbnb…",
    derivedNameHint: "Este nombre te ayuda a identificar la tarifa al mapear OTAs.",
    adjustmentType: "Tipo de ajuste",
    percentage: "Porcentaje",
    fixedAmount: "Importe fijo",
    adjustmentValue: "Valor del ajuste",
    adjustmentValueHint: "(negativo para descuento)",
    preview: "Vista previa",
    basePrice: "Precio base",
    increment: "Incremento",
    discount: "Descuento",
    cancel: "Cancelar",
    saving: "Guardando...",
    update: "Actualizar",
    create: "Crear",
    deleteModalTitle: "Eliminar tarifa",
    deleteWarnStrong: "Esta acción no se puede deshacer.",
    deleteWarnLead: "Vas a eliminar:",
    deleteCascadeLabel: "Eliminar también sus tarifas derivadas ({count})",
    deleteCascadeHint: "Si alguna derivada está vinculada a una OTA, se bloqueará la eliminación.",
    deleteConfirmLabel: "Escribe el nombre exacto para confirmar:",
    deleteConfirmPlaceholder: "Escribe exactamente el nombre",
    deleteConfirmHint: "Esto evita eliminaciones accidentales.",
    deleting: "Eliminando...",
    deleteConfirmBtn: "Eliminar definitivamente",
    copyModalTitle: "Copiar tarifa a otra unidad",
    copyOrigin: "Origen:",
    copyRate: "Tarifa:",
    copyTargetUnit: "Unidad destino",
    selectUnit: "Selecciona una unidad",
    copySameUnitHint: "No puedes copiar a la misma unidad.",
    copyTargetBaseRate: "Tarifa base destino",
    selectMainRate: "Selecciona una tarifa principal",
    copyDerivedHint: "Esta derivada se vinculará a esa tarifa principal en la unidad destino.",
    copyNoMainRates: "La unidad destino no tiene tarifas principales. Crea o copia una principal primero.",
    copyNewNameLabel: "Nombre en destino",
    copyRenameHint: "Puedes renombrar para evitar duplicados.",
    copyCascadeLabel: "Copiar también derivadas ({count})",
    copyCascadeHint: "Se crearán derivadas nuevas apuntando al rate plan principal copiado.",
    copying: "Copiando...",
    copyBtn: "Copiar",

    // Toasts / mensajes de script
    loadError: "Error cargando tarifas",
    rangeErrorSelect: "Debe seleccionar un rango de fechas válido",
    rangeErrorStartEnd: "La fecha de inicio no puede ser mayor a la fecha de fin",
    rangeErrorMinStay: "La estancia mínima es de {minStay} noches, pero el rango seleccionado tiene {nights} noches",
    invalidUnit: "Unidad inválida",
    completeRequired: "Completa los campos requeridos",
    updated: "Actualizado",
    created: "Creado",
    saveError: "Error guardando",
    deleted: "Eliminado",
    deleteLinkedOta: "No se puede eliminar: está vinculada a una OTA.",
    deleteGenericError: "Error eliminando",
    deleteDerivedError: "No se pudo eliminar la derivada",
    copied: "Copiado",
    copyGenericError: "Error copiando",
    invalidTargetUnit: "Unidad destino inválida",
    selectTargetBaseError: "Selecciona la tarifa base destino para vincular la derivada.",
    invalidTargetBaseError: "La tarifa base destino seleccionada no es válida para la unidad destino.",
    defaultRateName: "Tarifa",
    defaultDerivedName: "Derivada",
    copySuffix: "(Copia)",
  },
};
